export default __webpack_public_path__ + "static/media/team-6.18d1ade6.png";